import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map } from 'rxjs/operators';

@Injectable()
export class ProductService {

  constructor(private base: BaseService) { }

  save(data){
    return this.base.post('/api/product-save', data);
  }

  getAllProduct(){
    return  this.base.get('/api/all-product');
  }

  getProduct(id){
    return this.base.post('/api/get-product-details',{id:id});
  }

  getCategory()
  {
    return this.base.get('/api/get-all-category');
  }

  getSubCategory(id){
    return this.base.post('/api/get-cat-by-subCategory',{id:id});
  }
  productUpdate(data){
    return this.base.post('/api/product-update',data);
  }

  getProductInfo(id){
    return this.base.post('/api/get-product-details',{id:id});
  }

}
